import React from 'react';

/**
 * IconButton - Icon-only button component
 * Used for actions that only need an icon
 */
export const IconButton = ({ 
  icon, 
  onClick, 
  variant = 'default',
  size = 'md',
  className = '',
  'aria-label': ariaLabel,
  disabled = false
}) => {
  const variants = {
    default: 'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
    primary: 'text-blue-600 hover:text-blue-700 hover:bg-blue-50',
    danger: 'text-red-600 hover:text-red-700 hover:bg-red-50',
  };
  
  const sizes = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-2.5',
  };
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`inline-flex items-center justify-center rounded-lg transition-colors ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {icon}
    </button>
  );
};

export default IconButton;
